module.exports = "<div *ngIf=\"showLoader\" class=\"loading\">Loading&#8230;\n</div>\n<router-outlet>\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main